import { store } from '@redux/store';
import { filter, fromEvent, map, merge, of, switchMap } from 'rxjs';
import { segmentTrack } from 'features/segment';
import { selectPage } from 'features/articleSearchResultsFacets';

const bodyClick$ = fromEvent(document.body, 'click');
const getLinkableElement = (event) => event.target.closest('[data-page-link]');
const isAuthorArticlesSection =
    (event) => !!event.target.closest('[data-author-articles]');
const getArticleElement = (event) => event.target.closest('[data-article-card-link]');
const isArticleCard = (event) => !!event.target.closest('[data-article-card]');

const paginationContainer = document.querySelector('[data-component="blog-author-pagination"]');
const previousButton = paginationContainer.querySelector('[data-prev-button]');
const nextButton = paginationContainer.querySelector('[data-next-button]');
const optionList = paginationContainer.querySelector('[data-option-list]');

/**
 * Dispatches a Segment event when a recommendation article is clicked.
 * @param article - is the article clicked in recommendation articles section.
 */
const triggerRecommendedArticlesClick = (article) => {
  const customProperties = {
    article_title: article.dataset.title
  };

  store.dispatch(segmentTrack({ eventName: 'Related Article Clicked', customProperties }));
};

const onRecommendedArticlesClick$ = bodyClick$.pipe(
  filter((event) => !!event.target.closest('[data-section-name="recommendedArticles"]')),
  map(getArticleElement),
  filter(Boolean),
);

onRecommendedArticlesClick$.subscribe(triggerRecommendedArticlesClick);

/**
* Dispatches a Segment event When the pagination is clicked.
* @param customProperties - is the custom properties of the event.
*/
const triggerPaginationClickEvent = function(customProperties) {
  store.dispatch(segmentTrack({ eventName: 'Pagination Clicked', customProperties }));
}

// observable to emit the new page after previous button click event
const previousButton$ = fromEvent(previousButton, 'click').pipe(
  map(() => selectPage(store.getState())),
  map((page) => ({
      current_page: page-1,
      destination_page: page,
      navigation_method: 'previous',
  })),
);

// observable to emit the new page after next button click event
const nextButton$ = fromEvent(nextButton, 'click').pipe(
    map(() => selectPage(store.getState())),
    map((page) => ({
        current_page: page+1,
        destination_page: page,
        navigation_method: 'next',
    })),
);

// observable to emit the new page after option button click event
const optionList$ = fromEvent(optionList, 'click').pipe(
  switchMap((event) => {
      const linkableElement = getLinkableElement(event);
      if(linkableElement) {
          event.preventDefault();
      }

      const previousPage = selectPage(store.getState());
      const page = Number(linkableElement?.dataset?.pageLink || 0);
      return of({
          current_page: page,
          destination_page: previousPage,
          navigation_method: 'page_number',
      });
  })
);

merge(previousButton$, nextButton$, optionList$).subscribe(triggerPaginationClickEvent);

/**
 * Dispatches a Segment event for tracking article clicks with custom properties
 */
const triggerSearchResultArticlesClick = (data) => {
    const customProperties = {
      article_title: data.dataset.title,
      article_category: data.dataset.articleCategory,
      position: data.dataset.articlePosition,
    };

    store.dispatch(segmentTrack({ eventName: 'Author Article Clicked', customProperties }));
};

// observable to emit the article click event
const authorArticleSectionClick$ = bodyClick$.pipe(
  filter((event) => isAuthorArticlesSection(event) && isArticleCard(event)),
  map(getArticleElement),
  filter(Boolean),
);

authorArticleSectionClick$.subscribe(triggerSearchResultArticlesClick);
